import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireRole } from '@/lib/auth/guards';

const ContractDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.ContractDetailPage })));
const ContractFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.ContractFormPage })));
const ContractListPage = lazy(() => import('./list-page').then((m) => ({ default: m.ContractListPage })));

export const contractRoutes: RouteObject[] = [
  {
    path: 'contracts',
    handle: { crumb: 'Contracts' },
    children: [
      { index: true, element: <ContractListPage /> },
      {
        element: <RequireRole roles={['admin']} />,
        children: [
          { path: 'new', element: <ContractFormPage />, handle: { crumb: 'New contract' } },
          { path: ':id/edit', element: <ContractFormPage />, handle: { crumb: 'Edit' } },
        ],
      },
      { path: ':id', element: <ContractDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Contract' } },
    ],
  },
];
